type IArg = (...args: any[]) => void;

function debounce<F extends IArg>(func: F, delay: number): F {
  let timerId: ReturnType<typeof setTimeout> | undefined;

  return function makeDebounce(this: any, ...args: any[]) {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  } as F;
}

export default debounce;
